/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditGroupHasCheckinLimitApiRequest } from '../../models/hotel-edit-group-has-checkin-limit-api-request';

export interface ApiHotelManageEditGroupCheckinLimitPost$Params {
      body: HotelEditGroupHasCheckinLimitApiRequest
}

export function apiHotelManageEditGroupCheckinLimitPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditGroupCheckinLimitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditGroupCheckinLimitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditGroupCheckinLimitPost.PATH = '/api/hotel/manage/edit/group/checkin-limit';
